/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useEffect } from 'react';
import clsx from 'clsx';
import Loader from '../../atoms/Loader/Loader';
import * as styles from './AdjustItem.module.scss';
import { debounce } from 'lodash';
import Icon from '../../atoms/Icon/Icon';
import { IconButton } from '@chakra-ui/react';
import { useCartStore } from 'stores/cart';

const AdjustItem = ({
  item,
  updatingItem,
  updateCartItemQuantity,
  isCart,
  count,
  setItemCount,
  className
}) => {
  const isUpdating = updatingItem === item.id;
  const { setUpdatingCartItem } = useCartStore(state => state);
  const [qty, setQty] = useState(item.quantity);
  const classesAdjustButton = [styles.AdjustButton];
  if (className) {
    classesAdjustButton.push(className);
  }
  const classOutput = classesAdjustButton.join(' ');

  useEffect(() => {
    setQty(item.quantity);
  }, [item.quantity]);

  const handler = useCallback(
    debounce(quantity => {
      if (quantity !== '' && quantity !== '0') {
        updateCartItemQuantity(item, quantity);
      } else {
        setUpdatingCartItem(false);
      }
    }, 700),
    []
  );

  const handleOnChange = qty => {
    setUpdatingCartItem(true);
    handler(qty);
  };

  // For Cart Items
  const renderCartAdjustItem = () => {
    return (
      <div className={clsx(styles.root, isUpdating && 'disable-action')}>
        {isUpdating ? (
          <Loader />
        ) : (
          <div className={`${classOutput} ${qty < 2 && styles.disableButton}`}>
            <IconButton
              rounded={'none'}
              onClick={() => {
                if (qty > 1) {
                  setQty(qty - 1);
                  handleOnChange(qty - 1);
                }
              }}
              icon={<Icon symbol={'minus'} />}
            ></IconButton>

            <input
              type={'number'}
              value={qty}
              onChange={e => {
                setQty(e.target.value);
                handleOnChange(e.target.value);
              }}
            ></input>

            <IconButton
              rounded={'none'}
              onClick={() => {
                setQty(qty + 1);
                handleOnChange(qty + 1);
              }}
              icon={<Icon symbol={'plus'} />}
            ></IconButton>
          </div>
        )}
      </div>
    );
  };
  // Basic Count
  const renderBasicItemCount = () => {
    return (
      <div className={clsx(styles.rootCart, isUpdating && 'disable-action')}>
        <div
          data-button
          role="presentation"
          onClick={() => {
            if (count !== 0) {
              setItemCount(Number(count) - 1);
            }
          }}
        >
          <div className={styles.minusIconContainer}>
            <Icon symbol={'minus'}></Icon>
          </div>
        </div>

        <div>
          <input
            type={'number'}
            value={count}
            onChange={e => setItemCount(Number(e.currentTarget.value))}
          ></input>
        </div>

        <div data-button role="presentation" onClick={() => setItemCount(Number(count) + 1)}>
          <div className={styles.addIconContainer}>
            <Icon symbol={'plus'}></Icon>
          </div>
        </div>
      </div>
    );
  };

  return isCart ? renderCartAdjustItem() : renderBasicItemCount();
};

export default AdjustItem;
